import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const LedgersService = {
  // Get all ledgers with optional filters (ledgerTypeId, search, etc.)
  getList: async (params = {}) => {
    try {
      const response = await instance.get("/accounting/ledgers", {
        params,
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching ledgers:", error);
      throw error;
    }
  },

  // Get a single ledger by ID
  getById: async (id) => {
    try {
      const response = await instance.get(`/accounting/ledgers/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching ledger ${id}:`, error);
      throw error;
    }
  },

  // Create a new ledger
  create: async (data) => {
    try {
      const response = await instance.post("/accounting/ledgers", data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating ledger:", error);
      throw error;
    }
  },

  // Update an existing ledger
  update: async (id, data) => {
    try {
      const response = await instance.put(`/accounting/ledgers/${id}`, data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating ledger ${id}:`, error);
      throw error;
    }
  },

  // Delete a ledger
  delete: async (id) => {
    try {
      const response = await instance.delete(`/accounting/ledgers/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting ledger ${id}:`, error);
      throw error;
    }
  },
};

export default LedgersService;
